"use client";

import { useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";
import { handleButtonTracking } from "@/app/utils/button-tracking";

export default function ShareButton({
  postUrl,
  post,
}: {
  postUrl: string;
  post: { title: string; description: string };
}) {
  const [isShareOpen, setIsShareOpen] = useState(false);

  return (
    <div className="relative flex-shrink-0">
      <button
        onClick={() => {
          handleButtonTracking("clicked_blog_share_button");
          setIsShareOpen(!isShareOpen);
        }}
        className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-secondary transition-colors whitespace-nowrap"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z"
          />
        </svg>
        Share
      </button>

      {isShareOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsShareOpen(false)}
          />
          <div className="absolute right-0 mt-2 p-4 bg-panel rounded-lg shadow-lg border border-line z-20 flex gap-2">
            <TwitterShareButton url={postUrl} title={post.title}>
              <TwitterIcon size={40} round />
            </TwitterShareButton>
            <FacebookShareButton url={postUrl} title={post.title}>
              <FacebookIcon size={40} round />
            </FacebookShareButton>
            <LinkedinShareButton
              url={postUrl}
              title={post.title}
              summary={post.description}
            >
              <LinkedinIcon size={40} round />
            </LinkedinShareButton>
            <WhatsappShareButton url={postUrl} title={post.title}>
              <WhatsappIcon size={40} round />
            </WhatsappShareButton>
          </div>
        </>
      )}
    </div>
  );
}
